import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
      consultList: [],
      // token: '',
    },
    mutations: {
        setConsultList: (state, data) => {
            state.consultList = data
        },
        // setToken: (state, data) => {
        //     state.token = data
        // }
    },
    actions: {
      setConsultList: ({ commit }, key) => {
          localStorage.setItem('consultList', JSON.stringify(key))
          commit('setConsultList', key)
        },
      // setToken: ({ commit }, key) => {
      //     localStorage.setItem('token', JSON.stringify(key))
      //     commit('setToken', key)
      //   }
    },
    getters: {
        getConsultList: state => {
            let consultArray = state.consultList.length > 0 ? state.consultList : JSON.parse(localStorage.getItem('consultList')) || []
            return consultArray
        }
    }
})



// WEBPACK FOOTER //
// ./src/store.js